import { render } from "./eConsent_patient_sign.vue?vue&type=template&id=79440dff&scoped=true"
import script from "./eConsent_patient_sign.js?vue&type=script&lang=js"
export * from "./eConsent_patient_sign.js?vue&type=script&lang=js"

import "./eConsent_patient_sign.vue?vue&type=style&index=0&id=79440dff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79440dff"]])

export default __exports__